import FondationsServiceModel from '@/models/FondationsServiceModel';
import doc                    from '@widesk-core/decorators/doc';
import model                  from '@widesk-core/decorators/model';

@model.urnResource('user_deletion_request_status')
@doc.path('/user_deletion_request_statuses/{?id}')
export default class UserDeletionRequestStatusModel extends FondationsServiceModel {
	private declare _tsFilters: {
		'reference': UserDeletionRequestStatusReference;
	};

	@doc.string declare label: string;
	@doc.string declare reference: UserDeletionRequestStatusReference;
}